import { PANEL } from "./panelTokens";
import { panelListSectionTitleSx } from "./panelCardSx";

/** Ana panel sayfa başlığı — Hastalar ekranı referans tipografi */
export const panelPageTitleSx = {
  ...panelListSectionTitleSx,
  mb: 0,
  fontSize: "1.75rem",
  lineHeight: 1.2,
  textTransform: "none",
};

/** Tüm panel iç sayfaları — İstatistiksel Analiz referans başlık alt boşluğu */
const panelPageHeaderMarginBottom = { xs: 1.25, md: 1.5 };

/** Tüm panel iç sayfaları — paragraf alt başlık tipografisi */
const panelPageSubtitleTypography = {
  fontSize: { xs: "0.9rem", md: "1rem" },
  lineHeight: 1.5,
};

/** Ana panel sayfa alt başlığı */
export const panelPageSubtitleSx = {
  color: PANEL.text.muted,
  mt: 0.5,
  ...panelPageSubtitleTypography,
};

/** @deprecated panelPageHeaderShellSx.mb ile aynı — geriye uyumluluk */
export const panelInnerPageHeaderSx = {
  mb: panelPageHeaderMarginBottom,
};

/** @deprecated panelPageSubtitleSx ile aynı tipografi — geriye uyumluluk */
export const panelInnerPageSubtitleSx = panelPageSubtitleTypography;

/** Kart / tablo bölüm başlığı — örn. "Hasta Listesi" */
export const panelSectionTitleSx = {
  ...panelListSectionTitleSx,
  mb: 0,
  fontSize: "1rem",
  lineHeight: 1.35,
  textTransform: "none",
};

/** Sayfa üst başlık satırı kabuğu */
export const panelPageHeaderShellSx = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: panelPageHeaderMarginBottom,
  flexWrap: "wrap",
  gap: 2,
};

/** İkon + metin bloğu */
export const panelPageHeaderMainSx = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  minWidth: 0,
};

/** Sağ aksiyon alanı */
export const panelPageHeaderActionsSx = {
  display: "flex",
  gap: 1.5,
  alignItems: "center",
  flexWrap: "wrap",
  flexShrink: 0,
};

/** Bölüm başlığı satırı (chip / pagination ile) */
export const panelSectionHeaderRowSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  mb: 1.5,
  flexWrap: "wrap",
};
